import { render, staticRenderFns } from "./extract.vue?vue&type=template&id=27c28209&scoped=true"
import script from "./extract.vue?vue&type=script&lang=js"
export * from "./extract.vue?vue&type=script&lang=js"
import style0 from "./extract.vue?vue&type=style&index=0&id=27c28209&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c28209",
  null
  
)

export default component.exports